import { Component } from 'utils';
import { reportsActions } from '../../../../../store/reducers/reportsReducer';

@Component({
    controllerAs: 'vm',
    template: require('./reportData.tpl.html'),
    bindings: {
        data:'<',
    }
})
export class ReportSummeryDataComponent {
    static $inject = ['store'];

    get data() {
        return this._data;
    }

    set data(value) {
        if (value) {
            let filters = value;
            //hotfix for change the time into from date time00:00 and to date time 23:59
            let fromDate = moment(filters.fromDate);
            let toDate = moment(filters.toDate);
            if (filters.fromDate) {
                fromDate.startOf('day')
            }
            if (filters.toDate) {
                toDate.endOf('day');
            }
            this._store.dispatch({
                type: reportsActions.GET_AUDIT_REPORT_SUMMERY,
                payload: {
                    data : {
                        'Filters': [
                            { 'FilterName': 'SchemeIds', 'Value': filters.schema.id },
                            { 'FilterName': 'ObjectNames', 'Value': '' },
                            { 'FilterName': 'SearchType', 'Value': '1' },
                            { 'FilterName': 'FromDate', 'Value': fromDate.toDate() },
                            { 'FilterName': 'ToDate', 'Value': toDate.toDate() }
                        ]
                    }
                }
            });
            this.rows = [];
            this._data = value;
        }
    }

    constructor(store) {
        this._store = store;
        this.gridOptions = {
            enableRowSelection: false,
            enableSelectAll: false,
            enableColumnResizing: true,
            fastWatch: true,
            onRegisterApi: (gridApi) => {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { displayName: 'Instance Name', enablePinning: true, enableHiding: false, name: 'InstanceName' },
                {
                    displayName: 'Schema/Database Name', enablePinning: true, enableHiding: false, name: 'SchemaName', enableSorting: true,
                    sort: { direction: 'asc', priority: 1 }
                },
                { displayName: '# Operations', enablePinning: true, enableHiding: false, name: 'NumOfOperations' },
                { displayName: '# Approved/Blocked Ops', enablePinning: true, enableHiding: false, name: 'NumOfApprovedOps' },
                { displayName: '# Objects', enablePinning: true, enableHiding: false, name: 'NumOfObjects' },
                { displayName: '# Managed/Unmanaged Obj', enablePinning: true, enableHiding: false, name: 'NumOfManagedObjects' }
            ]
        };
        this.unSubscribe = this._store.subscribe(() => {
            if (this._data && this._store.getState().reports.report_summary ){
                this.gridOptions.data = this._store.getState().reports.report_summary;
            }
        });

        this.$onDestroy = () => {
            this.gridOptions.data = null;
            this.unSubscribe();
        }

        this.query = { order: 'name', };
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/reports/report-summrize/reportData/reportData.js